module.exports = __webpack_public_path__ + "static/media/discord-es.8f72cc1f.webp";